/**
 * @module:  招贤纳士页面相关
 * @author Liang Huang
 * @date 2020-10-14 09:52:40
 */
import { lazy } from 'react';
import { retry } from '@src/utils/tool';

// 招人才列表
export const ResumeList = lazy(() => retry(() => import('@Zhaopin/ResumeList/index')));
// 招人才搜索页面
export const ResumeSearch = lazy(() => retry(() => import('@Zhaopin/ResumeSearch/index')));
// 牛人详情页面
export const ResumeDetail = lazy(() => retry(() => import('@Zhaopin/ResumeDetail/index')));
// 工作经历
export const WorkExper = lazy(() => retry(() => import('@Zhaopin/WorkExper/index')));
export const ProjectExper = lazy(() => retry(() => import('@Zhaopin/ProjectExper/index')));
// 候选人列表页面
export const CandidateList = lazy(() => retry(() => import('@Zhaopin/CandidateList/index')));
// 候选人详情页面
export const CandidateDetail = lazy(() => retry(() => import('@Zhaopin/CandidateDetail/index')));
// 猎职位
export const HuntJob = lazy(() => retry(() => import('@Zhaopin/HuntJob/index')));
// 猎职位搜索
export const HuntJobSearch = lazy(() => retry(() => import('@Zhaopin/HuntJobSearch/index')));
// 猎职位列表页面
export const HuntJobList = lazy(() => retry(() => import('@Zhaopin/HuntJob/JobList')));
// 猎职位列表页面
export const HuntJobOffer = lazy(() => retry(() => import('@Zhaopin/HuntJob/HuntJobOffer')));
// 候选人搜索页面
export const CandidateSearch = lazy(() => retry(() => import('@Zhaopin/CandidateSearch/index')));
// 发布职位页面
export const PostPosition = lazy(() => retry(() => import('@Zhaopin/PostPosition/index')));
// 招贤纳士-职位管理
export const JobList = lazy(() => retry(() => import('@Zhaopin/JobList/index')));
// 商机列表
export const Business = lazy(() => retry(() => import('@Zhaopin/Business/index')));
// 商机搜索
export const BusinessSearch = lazy(() => retry(() => import('@Zhaopin/Business/Search/index')));
// 招贤纳士首页
export const ZhaopinHome = lazy(() => retry(() => import('@Zhaopin/Home/index')));
